import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Radio as AntRadio } from '@/shared/uikitV2/antd/Radio';

export const Radio = styled(AntRadio)`
  &&& {
    .ant-radio {
      padding-top: 4px;
      align-self: start;
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: ${COLORS.systemSky200};
      background-color: ${COLORS.systemSky200};
    }
  }
`;
